
import React, { useRef } from 'react';
import { UseCalendarViewResult } from '../types/calendar';

export const useCalendarView = (selectedDate: Date): UseCalendarViewResult => {
  const calendarRef = useRef<HTMLDivElement>(null);
  
  const getViewModeFromRoute = (): string => {
    const params = new URLSearchParams(window.location.search);
    const view = params.get('view');
    return view === 'week' ? 'timeGridWeek' : 
           view === 'list' ? 'listWeek' : 
           'dayGridMonth';
  };

  const [viewMode, setViewModeState] = React.useState<string>(getViewModeFromRoute());

  const setViewMode = (mode: string) => {
    setViewModeState(mode);
    
    // Update URL to reflect view mode
    const params = new URLSearchParams(window.location.search);
    const viewParam = mode === 'timeGridWeek' ? 'week' : 
                     mode === 'listWeek' ? 'list' : 
                     'month';
    params.set('view', viewParam);
    
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  };

  return {
    calendarRef,
    viewMode,
    setViewMode
  };
};
